import {
  normalizeCurrencyInputString,
  parseCurrencyInputNumber,
} from "@/lib/formatter";

const DEFAULT_DECIMAL_PLACES = 2;

function isEmptyServicePriceValue(value) {
  return value === null || value === undefined || value === "";
}

function getZeroDecimalSuffix(decimalPlaces = DEFAULT_DECIMAL_PLACES) {
  return `.${"0".repeat(decimalPlaces)}`;
}

function formatDecimalInputPrice(
  value,
  decimalPlaces = DEFAULT_DECIMAL_PLACES
) {
  const fixedValue = value.toFixed(decimalPlaces);
  const zeroDecimalSuffix = getZeroDecimalSuffix(decimalPlaces);

  return fixedValue.endsWith(zeroDecimalSuffix)
    ? fixedValue.slice(0, -zeroDecimalSuffix.length)
    : fixedValue;
}

function formatDecimalPrice(value, decimalPlaces = DEFAULT_DECIMAL_PLACES) {
  const inputPrice = formatDecimalInputPrice(value, decimalPlaces);
  const hasDecimal = inputPrice.indexOf(".") !== -1;

  return Number(inputPrice).toLocaleString(undefined, {
    minimumFractionDigits: hasDecimal ? decimalPlaces : 0,
    maximumFractionDigits: decimalPlaces,
  });
}

export function sanitizeServicePriceInput(
  value,
  decimalPlaces = DEFAULT_DECIMAL_PLACES
) {
  if (value === null || value === undefined) {
    return value;
  }

  const normalizedValue = normalizeCurrencyInputString(value);
  const decimalPointIndex = normalizedValue.indexOf(".");

  if (decimalPointIndex === -1) {
    return normalizedValue;
  }

  const integerPart = normalizedValue.slice(0, decimalPointIndex);
  const decimalPart = normalizedValue.slice(
    decimalPointIndex + 1,
    decimalPointIndex + 1 + decimalPlaces
  );

  return `${integerPart}.${decimalPart}`;
}

export function sumServicePriceInputValues(values) {
  const total = (values || []).reduce((sum, value) => {
    const price = parseCurrencyInputNumber(sanitizeServicePriceInput(value));

    return price === null ? sum : sum + price;
  }, 0);

  return total.toFixed(DEFAULT_DECIMAL_PLACES);
}

export function formatServicePriceDisplay(
  value,
  decimalPlaces = DEFAULT_DECIMAL_PLACES
) {
  if (isEmptyServicePriceValue(value)) {
    return value;
  }

  const price = parseCurrencyInputNumber(value);

  if (price === null) {
    return null;
  }

  return formatDecimalPrice(price, decimalPlaces);
}

export function formatServicePriceInputValue(value, shouldFormat) {
  const hasNumericFormStateValue = typeof value === "number";

  if (!shouldFormat && !hasNumericFormStateValue) {
    return value;
  }

  const price = parseCurrencyInputNumber(value);

  return price === null
    ? "0"
    : formatDecimalInputPrice(price);
}
